/**
 * Dashboard Page Component
 */

import React from 'react';
import {
  Box,
  Paper,
  Typography,
  Card,
  CardContent,
  LinearProgress,
} from '@mui/material';
import {
  TrendingUp,
  Home,
  Assessment,
  AccountBalanceWallet,
} from '@mui/icons-material';

function DashboardPage() {
  // Mock data - will be replaced with real API calls
  const stats = [
    {
      title: 'Total Properties Analyzed',
      value: '127',
      icon: <Home sx={{ fontSize: 40 }} />,
      color: '#1976d2',
      change: '+12%',
    },
    {
      title: 'Average ROI Score',
      value: '8.4',
      icon: <TrendingUp sx={{ fontSize: 40 }} />,
      color: '#2e7d32',
      change: '+0.8',
    },
    {
      title: 'Portfolio Value',
      value: '$2.4M',
      icon: <AccountBalanceWallet sx={{ fontSize: 40 }} />,
      color: '#ed6c02',
      change: '+5.2%',
    },
    {
      title: 'Active Analyses',
      value: '23',
      icon: <Assessment sx={{ fontSize: 40 }} />,
      color: '#9c27b0',
      change: '+3',
    },
  ];

  return (
    <Box>
      <Typography variant="h4" gutterBottom sx={{ fontWeight: 600, mb: 3 }}>
        Welcome back to DealFlow AI
      </Typography>
      
      {/* Stats Cards */}
      <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 3, mb: 4 }}>
        {stats.map((stat, index) => (
          <Card key={index} sx={{ flex: '1 1 300px', minWidth: 250 }} elevation={2}>
            <CardContent>
              <Box display="flex" alignItems="center" justifyContent="space-between">
                <Box>
                  <Typography color="textSecondary" gutterBottom variant="body2">
                    {stat.title}
                  </Typography>
                  <Typography variant="h4" sx={{ fontWeight: 600, mb: 1 }}>
                    {stat.value}
                  </Typography>
                  <Typography 
                    variant="body2" 
                    sx={{ 
                      color: stat.change.startsWith('+') ? 'success.main' : 'error.main',
                      fontWeight: 500 
                    }}
                  >
                    {stat.change} from last month
                  </Typography>
                </Box>
                <Box sx={{ color: stat.color }}>
                  {stat.icon}
                </Box>
              </Box>
            </CardContent>
          </Card>
        ))}
      </Box>

      {/* Main Content */}
      <Box sx={{ display: 'flex', gap: 3, flexWrap: 'wrap' }}>
        {/* Recent Activity */}
        <Paper sx={{ p: 3, flex: '2 1 500px', minWidth: 400 }}>
          <Typography variant="h6" gutterBottom sx={{ fontWeight: 600 }}>
            Recent Property Analyses
          </Typography>
          <Box sx={{ mt: 2 }}>
            {[1, 2, 3, 4, 5].map((item) => (
              <Box key={item} sx={{ mb: 2, p: 2, border: '1px solid #e0e0e0', borderRadius: 1 }}>
                <Box display="flex" justifyContent="space-between" alignItems="center">
                  <Box>
                    <Typography variant="subtitle1" sx={{ fontWeight: 600 }}>
                      123 Main St, San Francisco, CA
                    </Typography>
                    <Typography variant="body2" color="textSecondary">
                      Analyzed 2 hours ago
                    </Typography>
                  </Box>
                  <Box textAlign="right">
                    <Typography variant="h6" sx={{ fontWeight: 600, color: 'success.main' }}>
                      8.7/10
                    </Typography>
                    <Typography variant="body2" color="textSecondary">
                      ROI Score
                    </Typography>
                  </Box>
                </Box>
              </Box>
            ))}
          </Box>
        </Paper>

        {/* Quick Actions */}
        <Paper sx={{ p: 3, flex: '1 1 300px', minWidth: 300 }}>
          <Typography variant="h6" gutterBottom sx={{ fontWeight: 600 }}>
            Market Insights
          </Typography>
          <Box sx={{ mt: 2 }}>
            <Box sx={{ mb: 3 }}>
              <Typography variant="body2" color="textSecondary" gutterBottom>
                San Francisco Market Trend
              </Typography>
              <LinearProgress 
                variant="determinate" 
                value={75} 
                sx={{ height: 8, borderRadius: 4 }}
              />
              <Typography variant="body2" sx={{ mt: 1, fontWeight: 500 }}>
                Strong Growth (+12.5%)
              </Typography>
            </Box>
            
            <Box sx={{ mb: 3 }}>
              <Typography variant="body2" color="textSecondary" gutterBottom>
                Average Days on Market
              </Typography>
              <Typography variant="h5" sx={{ fontWeight: 600 }}>
                28 days
              </Typography>
              <Typography variant="body2" color="success.main">
                -3 days from last month
              </Typography>
            </Box>

            <Box>
              <Typography variant="body2" color="textSecondary" gutterBottom>
                Investment Opportunities
              </Typography>
              <Typography variant="h5" sx={{ fontWeight: 600 }}>
                47 deals
              </Typography>
              <Typography variant="body2" color="info.main">
                matching your criteria
              </Typography>
            </Box>
          </Box>
        </Paper>
      </Box>
    </Box>
  );
}

export default DashboardPage;
